import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, Route } from 'react-router';
import {
  AddHostPage,
  DebugPage,
  EditHostPage,
  EnrollPage,
  HostDetailPage,
  HostsPage,
} from '#route-bundles/authenticated.tsx';
import { fallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { page, Titled } from '#util/title.ts';

/**
 * {@link hostsRootRoute} contains all of the routing config for the /hosts path
 */
export const hostsRootRoute = (
  <Route
    element={
      <Titled title={() => page('Hosts')}>
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </Titled>
    }
  >
    <Route index={true} element={<HostsPage />} />
    <Route path="add" element={<AddHostPage />} />
    <Route
      path=":hostId"
      element={
        <ErrorBoundary fallbackRender={fallbackRenderNotFound}>
          <Outlet />
        </ErrorBoundary>
      }
    >
      <Route
        index={true}
        element={
          <Titled title={() => page('Host')}>
            <HostDetailPage />
          </Titled>
        }
      />
      <Route path="edit" element={<EditHostPage />} />
      <Route
        path="enroll"
        element={
          <Titled title={() => page('Enroll host')}>
            <EnrollPage />
          </Titled>
        }
      />
      <Route path="debug" element={<DebugPage />} />
    </Route>
  </Route>
);
